
<d-contract-edit
    v-model        = "edit"
    :title         = "isLim ? 'Liftmanagement' : 'DLS'"
    :type-id       = "typeId"
    :contract-id   = "contractId"
    :company-id    = "companyId"
    :customer-id   = "companyId"
    :show-customer = "false"
    @initialized   = "onInitialized"
    @saved         = "onSaved"
>
    <template v-slot:terms>
        <div class="pt-0 h-100">
            <c-contract-lim-terms
                :contract   = "contract"
                :key        = "refresh"
                :show-title = "false"
                style       = "margin-top: -4px;"
            />
        </div>
    </template>
    <template v-slot:post>
        <v-row class="no-frame" v-if="isLim">
            <v-col class="no-frame pr-2">
                <f-currency-field
                    class     = "money"
                    :label    = "$t('contract.lim.pricePerMonth')"
                    v-model   = "contract.pricePerMonth"
                    :rules    = "[ requiredRule ]"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-currency-field
                    class     = "money"
                    :label    = "$t('contract.lim.lgsPerMonth')"
                    v-model   = "contract.lgsPerMonth"
                />
            </v-col>
        </v-row>
    </template>
</d-contract-edit>
